<div class="input date">
  <input
    #dateInput
    [matDatepicker]="datepicker"
    [ngStyle]="config()?.inputStyles"
    [ngModel]="internalValue()"
    (ngModelChange)="onDateChange($event)"
    (click)="openDatePicker()"
    [autoSlashDateInput]="currentDateFormat"
    type="text"
    class="string-input"
  />
  <mat-datepicker
    #datepicker
    panelClass="bl-datepicker with-theme"
    [startView]="'month'"
    [touchUi]="false"
    [restoreFocus]="true"
    [calendarHeaderComponent]="datepickerHeader"
    (opened)="pickerOpened.emit()"
    (closed)="pickerClosedFn()"
  />
</div>
